import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader, BarcodeFormat } from "@zxing/browser";
import { useDispatch } from "react-redux";
import { showAlert } from '../../store/slices/alertSlice';
function ZXingScanner({ onScan }) {
  const videoRef = useRef(null);
  const codeReaderRef = useRef(null);
  const controlsRef = useRef(null);
  const dispatch = useDispatch();
  // 🔒 lock to prevent consecutive scans
  const [scanLock, setScanLock] = useState(false);
  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader();
    codeReaderRef.current = codeReader;

    // ✅ Explicitly set supported barcode formats (including European types)
    const formats = [
      BarcodeFormat.AZTEC,
      BarcodeFormat.CODABAR,
      BarcodeFormat.CODE_39,
      BarcodeFormat.CODE_93,
      BarcodeFormat.CODE_128,
      BarcodeFormat.DATA_MATRIX,
      BarcodeFormat.EAN_8,
      BarcodeFormat.EAN_13,
      BarcodeFormat.ITF,
      BarcodeFormat.MAXICODE,
      BarcodeFormat.PDF_417,
      BarcodeFormat.QR_CODE,
      BarcodeFormat.RSS_14,
      BarcodeFormat.RSS_EXPANDED,
      BarcodeFormat.UPC_A,
      BarcodeFormat.UPC_E,
      BarcodeFormat.UPC_EAN_EXTENSION
    ];

    codeReader.decodeFromVideoDevice(
        null,
        videoRef.current,
        (result, error, controls) => {
        if (result && !scanLock) {
          setScanLock(true); // 🔒 lock scanner
          
       
            if (onScan) onScan(result.getText());
           
          // release lock after 1 second (adjust as needed)
          setTimeout(() => setScanLock(false), 1000);
          
          if (controls) controls.stop();
        } else if (error && error.name !== 'NotFoundException') {
          // optional error handling
          }

          controlsRef.current = controls;
        },
      { formats }
    ).catch(() => {
        dispatch(showAlert({ severity: 'error', title: 'Camera error.' }));

      });

    return () => {
      if (controlsRef.current) controlsRef.current.stop();
    };
  }, [onScan, dispatch, scanLock]);

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted
      style={{ width: "100%", maxWidth: "500px", border: "2px solid black" }}
    />
  );
}

export default ZXingScanner;
